document.addEventListener('DOMContentLoaded', () => {
  // 1. Získáme všechny hlavní obrázky produktu na stránce
  const rawImages = document.querySelectorAll('#product-information .product-media-container img');
  if (rawImages.length === 0) return;

  let imageUrls = [];
  
  // 2. Vyfiltrujeme unikátní URL (aby se nám neduplikovaly náhledy) a navěsíme click event
  rawImages.forEach((img) => {
    // Bereme jen skutečné produktové fotky z CDN
    if (img.src && img.src.includes('cdn/shop/files')) {
      // Pokud URL ještě nemáme, přidáme ji do našeho pole
      if (!imageUrls.includes(img.src)) {
        imageUrls.push(img.src);
      }
      
      // Nastavíme fotkám kurzor lupy, aby uživatel věděl, že na ně jde kliknout
      img.style.cursor = 'zoom-in';
      
      // Interceptneme kliknutí na fotku
      img.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation(); // Zablokuje jakékoliv zbytky Savor skriptů
        
        // Zjistíme, na kolikátou fotku uživatel klikl, a otevřeme lightbox
        const clickedIndex = imageUrls.indexOf(img.src);
        openCustomLightbox(clickedIndex > -1 ? clickedIndex : 0);
      });
    }
  });

  // 3. Funkce, která postaví okno od nuly
  function openCustomLightbox(startIndex) {
    // Sestavíme HTML s naším overlayem a Swiper strukturou
    const lbHtml = `
      <div id="MyCustomLightbox">
        <button class="custom-lb-close" aria-label="Zavřít">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"></path>
          </svg>
        </button>
        <div class="swiper my-lightbox-swiper">
          <div class="swiper-wrapper">
            ${imageUrls.map(url => `<div class="swiper-slide"><img src="${url}" loading="lazy"></div>`).join('')}
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
    `;
    
    // Vhodíme HTML na úplný konec stránky (bezpečné místo)
    document.body.insertAdjacentHTML('beforeend', lbHtml);

    const lightboxEl = document.getElementById('MyCustomLightbox');
    const closeBtn = lightboxEl.querySelector('.custom-lb-close');

    // Inicializujeme Swiper
    const swiper = new Swiper('.my-lightbox-swiper', {
      initialSlide: startIndex,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      keyboard: {
        enabled: true, // Fungují i šipky na klávesnici!
      },
      grabCursor: true,
      loop: imageUrls.length > 1 // Smyčka jen pokud je víc než 1 fotka
    });

    // Fade-in animace okna
    requestAnimationFrame(() => {
      lightboxEl.classList.add('active');
    });

    // Zavírání okna
    const closeLightbox = () => {
      lightboxEl.classList.remove('active');
      setTimeout(() => {
        swiper.destroy(true, true);
        lightboxEl.remove();
      }, 300); // Počkáme na dokončení CSS opacity animace
    };

    closeBtn.addEventListener('click', closeLightbox);
    
    // Zavření kliknutím na prázdné pozadí (mimo fotku)
    lightboxEl.addEventListener('click', (e) => {
      if(e.target === lightboxEl || e.target.classList.contains('swiper-slide')) {
        closeLightbox();
      }
    });
    
    // Zavření přes klávesu ESC
    document.addEventListener('keydown', function escListener(e) {
      if (e.key === 'Escape') {
        closeLightbox();
        document.removeEventListener('keydown', escListener);
      }
    });
  }
});

